import { render } from "./report.vue?vue&type=template&id=732b487a&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"

import "./report.vue?vue&type=style&index=0&id=732b487a&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732b487a"]])

export default __exports__